/* 🤖 this file was generated by svg-to-ts */
export const matIconCompress: {
  name: 'compress';
  data: string;
} = {
  name: 'compress',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M4 9v2h16V9H4zm12-5-1.41-1.41L13 4.17V1h-2v3.19L9.39 2.61 8 4l4 4 4-4zM4 14h16v-2H4v2zm4 5 1.39 1.39L11 18.81V22h2v-3.17l1.59 1.59L16 19l-4-4-4 4z"/></svg>`
};
